import React from 'react';
import { motion } from 'framer-motion';
import './Gallery.css';

const galleryItems = [
  { id: 1, title: '3D Printed Architecture Model', category: '3D Print', span: 'wide' },
  { id: 2, title: '3D Printed Sculpture', category: '3D Print', span: 'normal' },
  { id: 3, title: '3D Printed Miniature', category: '3D Print', span: 'normal' },
  { id: 4, title: '3D Printed Prototype', category: '3D Print', span: 'wide' },
  { id: 5, title: '3D Printed Art Piece', category: '3D Print', span: 'normal' },
  { id: 6, title: '3D Printed Custom Design', category: '3D Print', span: 'normal' },
  ];
const gradients = [
  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
];

function Gallery() {
  return (
    <section className="gallery section-padding" id="gallery">
      <div className="container">
        <motion.div
          className="gallery__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">3D PRINTS</span>
          <h2 className="section-title">
            My 3D printing
            <span className="text-gradient">creations & hobby</span>
          </h2>
        </motion.div>

        <div className="gallery__grid">
          {galleryItems.map((item, i) => (
            <motion.div
              key={item.id}
              className={`gallery__item ${item.span === 'wide' ? 'gallery__item--wide' : ''}`}
              initial={{ opacity: 0, y: 40, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: 0.08 * i }}
              whileHover={{ y: -6, transition: { duration: 0.3 } }}
            >
              <div
                className="gallery__item-bg"
                style={{ background: gradients[i % gradients.length] }}
              />
              <div className="gallery__item-placeholder">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
              <div className="gallery__item-overlay">
                <span className="gallery__item-category">{item.category}</span>
                <h3 className="gallery__item-title">{item.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Gallery;
